import { RoutingService, TranslatePipe } from '@spartacus/core';
import { Component, OnInit } from '@angular/core';
import { RemoveLeadingZerosPipe } from '../../../shared/pipe/kn-br-custom-pipes/remove-leading-zeros.pipe';

@Component({
    selector: 'knbr-kn-br-order-acknowledge',
    templateUrl: './kn-br-order-acknowledge.component.html',
    styleUrls: ['./kn-br-order-acknowledge.component.scss'],
    imports: [TranslatePipe, RemoveLeadingZerosPipe]
})
export class KnBrOrderAcknowledgeComponent implements OnInit {
  orderCode: string;
  type: string;
  rma: string;
  orderNumber: string;
  constructor(private routingService: RoutingService) {
    this.routingService
      .getRouterState()
      .subscribe((state) => {
        if (state && state.state && state.state.params && state.state.params.orderCode) {
          this.orderCode = state.state.params.orderCode;
          this.type = state.state.params.type;
          this.rma = state.state.params.rma;
          this.orderNumber = state.state.params.orderNumber;
        }
      })
      .unsubscribe();
  }

  ngOnInit(): void {}

  returnRequestDetails() {
        this.routingService.go({ cxRoute: 'returnRequestDetails', params: { code: this.rma } });
      }

  goToOrderDetails() {
    this.routingService.go({ cxRoute: 'orderDetails', params: { code: this.orderCode } });
  }

  goToOrderList() {
    this.routingService.go({ cxRoute: 'orders' });
  }
}
